import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock, Target, TrendingUp, CheckCircle } from 'lucide-react';

interface ReviewerMetricsCardsProps {
  metrics: {
    avgTurnaroundDays: number;
    targetTurnaroundDays: number;
    avgReviewHours: number;
    targetReviewHours: number;
    completedReviews: number;
    onTimeReviews: number;
  };
}

export const ReviewerMetricsCards = ({ metrics }: ReviewerMetricsCardsProps) => {
  const onTimePercentage = metrics.completedReviews > 0 
    ? Math.round((metrics.onTimeReviews / metrics.completedReviews) * 100) 
    : 0;

  const efficiencyPercentage = metrics.targetReviewHours > 0 
    ? Math.round((metrics.targetReviewHours / metrics.avgReviewHours) * 100) 
    : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Avg Turnaround</CardTitle>
          <Clock className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{metrics.avgTurnaroundDays} days</div>
          <p className="text-xs text-muted-foreground">
            Target: {metrics.targetTurnaroundDays} days
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Review Efficiency</CardTitle>
          <Target className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{efficiencyPercentage}%</div>
          <p className="text-xs text-muted-foreground">
            {metrics.avgReviewHours}h avg vs {metrics.targetReviewHours}h target
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">On-Time Reviews</CardTitle>
          <CheckCircle className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{onTimePercentage}%</div>
          <p className="text-xs text-muted-foreground">
            {metrics.onTimeReviews} of {metrics.completedReviews} completed
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Performance Trend</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-green-600">+12%</div>
          <p className="text-xs text-muted-foreground">
            vs last month
          </p>
        </CardContent>
      </Card>
    </div>
  );
};